
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteVehicle } from '../../firebase-services/db-services'
import { getVehiclesFetch, selectVehicles, setActiveVehicle } from '../../Redux/slices/vehicleState'
import ConfirmDIalouge from '../ConfirmDIalouge'
import {  toast } from 'react-toastify';
import VehicleCard from './VehicleCard'
export default function ViewVehicles({setEditHandler}) {
    const dispatch = useDispatch()
    const vehicles = useSelector(selectVehicles)
    const [selectDelete,setSelectDelete] = useState(false)
    

    const deleteHandler = ()=>{
        deleteVehicle(selectDelete).then(()=>{
            setEditHandler({docid:false})()
            dispatch(setActiveVehicle(null))
            dispatch(getVehiclesFetch())
            setSelectDelete(false)
            toast.success("Vehicle Deleted Successfully")
        }).catch((e)=>{
            toast.error("Failed to delete vehicle")
            console.log(e)
        })
    }
    const closeHandler=()=>{
        setSelectDelete(false)
    }
    useEffect(() => {
        dispatch(getVehiclesFetch())
        return () => {

        }
    }, [dispatch])

    return (
        <section className="text-gray-600 body-font">
            {selectDelete&&<ConfirmDIalouge message={`Delete Vehicle`} desc="Are you sure want to delete this Vehicle and it's related info" action='Confirm'  actionHandler={deleteHandler} closeHandler={closeHandler}/>}
            <div className="container px-5 py-10 mx-auto">
                <div className="flex flex-wrap -m-2">
                    {vehicles.map((vehicle,i)=><VehicleCard key={i} {...vehicle} setEditHandler={setEditHandler(vehicle)} setSelectDelete={setSelectDelete}/>)}
                </div>
            </div>
        </section>
    )
}
